import * as React from 'react'

export function useAssertStableReference<T> (value: T): void {
  const ref = React.useRef(value)

  if (window.env !== 'production' && ref.current !== value) {
    throw new Error('Reference changed between renders. Ensure it is memoized or defined outside the component.')
  }

  ref.current = value
}